import {Button, Modal, ModalHeader, ModalContent, Dropdown, Input, Checkbox, Message} from "semantic-ui-react"
import { useEffect, useState } from 'react'
import { ActionButton } from "../common"
import {getCSRFToken, fetchWithAuth} from "../auth"
import {ASSOCIATE_ROLES} from "../../constants/common"
import {validEmail} from "../common/helpers";

export const AddMemberModal = props => {
    const members = props.members
    const [open, setOpen] = useState(false)
    const [roleOptions, setRoleOptions] = useState([])
    const [modalContent, setModalContent] = useState(<></>)
    const [supervisor, setSupervisor] = useState()
    const [role, setRole] = useState()
    const [teams, setTeams] = useState([])
    const [selectedTeams, setSelectedTeams] = useState([])
    const [teamDisabled, setTeamDisabled] = useState(true)
    const [id, setId] = useState('')
    const [name, setName] = useState('')
    const [jobTitle, setJobTitle] = useState('')
    const [addMemberError, setAddMemberError] = useState('')
    const [loginAccess, setLoginAccess] = useState({
        enabled: false,
        email: null
    })

    useEffect(() => {
        setSelectedTeams([])
        if(role) {
            setTeamDisabled(false)
        }
    }, [role])

    useEffect(() => {
        resetModal()
    }, [teamDisabled, selectedTeams])

    function closeModal() {
        setOpen(false)
        setRole()
        setId()
        setName()
        setSupervisor()
        setJobTitle()
        setSelectedTeams()
        setTeamDisabled(true)
        resetModal()
    }

    const getTeams = async () => {
        const resp = await fetchWithAuth(process.env.REACT_APP_ICC_TOOL_API_HOST + 'teams/', {
            headers: {
                'X-CSRFToken': getCSRFToken()
            },
            credentials: 'include'
        })
        const respJson = await resp.json()
        setTeams(respJson)
    }

    async function handleResp(resp) {
        if (resp.status >= 400) {
            const respText = await resp.text()
            setModalContent((
                <div style={{ margin: "1rem", display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <div>
                        There was an error: {respText}
                    </div>
                    <Button onClick={closeModal}>Close</Button>
                </div>
            ))
            return true
        } else {
            setModalContent((
                <div style={{ margin: "2rem", display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <div>
                        Success!
                    </div>
                    <Button style={{ margin: "1rem" }} onClick={closeModal}>Close</Button>
                </div>
            ))
            return false
        }
    }

    const isFormValid = () => {
        if (loginAccess.enabled === true) {
            if (loginAccess.email === undefined || loginAccess.email === null || loginAccess.email === '') {
                setAddMemberError("An email address is required to enable login access.")
                return false
            }
            if (!validEmail(loginAccess.email)) {
                setAddMemberError("Please enter a valid email address.");
                return false
            }
        }
        return true
    }

    function addMember() {

        let teamIds = selectedTeams
        if (selectedTeams && !Array.isArray(selectedTeams)){
            teamIds = [selectedTeams]
        }

        if (!isFormValid()){
          window.scrollTo({ top: 0, behavior: 'smooth' })
          return
        }

        async function postAddMember() {
            const resp = await fetchWithAuth(process.env.REACT_APP_ICC_TOOL_API_HOST + 'members/', {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    'X-CSRFToken': getCSRFToken()
                },
                credentials: 'include',
                body: JSON.stringify({
                    userId: id,
                    name: name,
                    role: role,
                    supervisor: supervisor,
                    jobTitle: jobTitle,
                    teamIds: teamIds,
                    loginAccess: loginAccess
                })
            })
            await handleResp(resp)

            props.refresh()


        }
        setModalContent(<div>Loading...</div>)
        postAddMember()
    }

    async function getRoleOptions() {
        const resp = await fetchWithAuth(process.env.REACT_APP_ICC_TOOL_API_HOST + 'roles/', {
            headers: {
                'X-CSRFToken': getCSRFToken()
            },
            credentials: 'include'
        })
        const respJson = await resp.json()
        setRoleOptions(respJson)
    }

    useEffect(() => {
        resetModal()
    }, [id, name, jobTitle, loginAccess, addMemberError])

    function resetModal() {
        const content = (
            <>
                <ModalHeader>Add a member</ModalHeader>
                <ModalContent>
                    <div className="add-member-wrapper">
                        {addMemberError &&
                          <Message negative>{addMemberError}</Message>
                        }
                        <div className="add-member">
                            <Input required={true} name="id" value={id} onChange={(e, data) => {setId(data.value.toLowerCase())}} className="field-input spaced" placeholder="ID"></Input>
                            <Input required={true} name="name" value={name} onChange={(e, data) => {setName(data.value)}} className="field-input spaced" placeholder="Name"></Input>
                            <Input required={true} name="jobTItle" value={jobTitle} onChange={(e, data) => {setJobTitle(data.value)}} className="field-input spaced" placeholder="Job Title"></Input>
                            <Dropdown className="spaced" placeholder="Role" value={role} onChange={(e, data) => {setRole(data.value)}} fluid selection options={
                                roleOptions.map(role => {
                                    return {
                                        key: role.key,
                                        value: role.value,
                                        text: role.value
                                    }
                                })
                            } />
                            <Dropdown className="spaced" placeholder="Supervisor" value={supervisor} onChange={(e, data) => {setSupervisor(data.value)}} fluid search selection options={
                                members.filter(member => {
                                    // Only return roles that are not in ASSOCIATE_ROLES
                                    return !ASSOCIATE_ROLES.includes(member.role.toLowerCase())
                                }).map(member => {
                                    return {
                                        key: member.userId,
                                        value: member.userId,
                                        text: member.name
                                    }
                                })
                            } />
                            <Dropdown
                                className="spaced"
                                placeholder="Team(s)"
                                value={selectedTeams}
                                onChange={(e, data) => {setSelectedTeams(data.value)}}
                                disabled={teamDisabled}
                                fluid search selection
                                multiple={!ASSOCIATE_ROLES.includes(String(role).toLowerCase())}
                                options={
                                teams.map(team => {
                                    return {
                                        key: team.id,
                                        value: team.id,
                                        text: team.name
                                    }
                                })
                            } />
                            <Checkbox
                                style={{marginTop: '1rem', marginBottom: '1rem'}}
                                label="Enable Login Access"
                                toggle
                                checked={loginAccess.enabled}
                                value={loginAccess.enabled}
                                onChange={(_, data) => {
                                    setLoginAccess((prevDict => ({
                                      ...prevDict,
                                      enabled: data.checked
                                    })))
                                    if (data.checked === false) {
                                        setAddMemberError('')
                                    }
                                }}
                            />
                            {loginAccess.enabled &&
                                <Input
                                    name="loginEmail"
                                    value={loginAccess.email}
                                    onChange={(e, data) => {
                                        setLoginAccess((prevDict => ({
                                          ...prevDict,
                                          email: data.value
                                        })))
                                    }}
                                    className="field-input spaced"
                                    placeholder="Email">
                                </Input>
                            }
                            <div style={{paddingTop: "1rem"}}>
                                <ActionButton submitAction={addMember}
                                    resetHide={false}
                                    resetText={'Cancel'}
                                    showConfirmation={false}
                                    resetAction={closeModal} />
                            </div>
                        </div>
                    </div>
                </ModalContent>
            </>)
        setModalContent(content)
    }

    useEffect(() => {
        resetModal()
    }, [roleOptions])

    useEffect(() => {
        getRoleOptions()
        getTeams()
    }, [])
    return (<Modal
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        open={open}
        size={'mini'}
        trigger={<Button style={{backgroundColor: "var(--add)", color: "white"}}>Add a member</Button>}
    >{modalContent}</Modal>)
}
